import React, { useEffect, useRef, useState } from 'react';
import Main from '../../../../components/Main/Main.jsx';
import InputGlobal from '../../../../components/InputGlobal.jsx';
import { useForm } from 'react-hook-form';
import Form from '../../../../components/Main/Form.jsx';
import ButtonGlobal from '../../../../components/ButtonGlobal.jsx';
import Title from '../../../../components/Title.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { postEntradaNfProductThunk } from '../../../../slices/entradaProductSlice.js';
import { resetOut } from '../../../../slices/entradaProductSlice.js';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Trash2 } from 'lucide-react';
import { Tooltip, Typography } from '@material-tailwind/react';
import Adicionar from '../../../../components/Buttons/Adicionar.jsx';
import MsgSucess from '../../../../components/MsgSucess.jsx';
import { products } from '../../../../slices/productSlice.js';
import ProdutoCod from '../../../../components/autoComplet/ProdutoCod.jsx';
import MsgInputError from '../../../../components/MsgInputError.jsx';
import usePageTitle from '../../../../hook/usePageTitle.js';

const Entradas = () => {
  usePageTitle();

  const dispatch = useDispatch();
  const [produtos, setProdutos] = useState([]);
  const { success, loading } = useSelector((state) => state.entrada);
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm();
  const [winthor, setWinthor] = useState(null);
  const [inputValue, setInputValue] = React.useState('');
  const [formRequired, setFomrRequired] = useState(false);
  const inputRefProduto = useRef(null);

  useEffect(() => {
    setValue('produtoWinthor', winthor);
    setFomrRequired(false);
  }, [winthor]);

  const cleanCamp = () => {
    setValue('nome', '');
    setValue('produto', '');
    setValue('quantidade', '');
    setValue('preco', '');
    setInputValue('');
    setWinthor(null);
  };

  const removeItemProduto = (index) => {
    setProdutos((prevLista) => {
      const novaLista = [...prevLista]; // Faz uma cópia da lista
      novaLista.splice(index, 1); // Remove o item no índice especificado
      return novaLista; // Retorna a nova lista
    });
  };

  const resetInfo = () => {
    setInputValue('');
    setWinthor(null);
    reset();
    setProdutos([]);
    dispatch(resetOut());
    dispatch(products());
  };

  useEffect(() => {
    return () => resetInfo();
  }, []);

  const addProduct = (data) => {
    if (!winthor) {
      setFomrRequired(true);
      return;
    }
    const { quantidade, preco } = data;
    const produto = data.produtoWinthor.id;
    const nome = data.produtoWinthor.nome;
    const formPreco = parseFloat(preco).toFixed(2);
    const dados = {
      produto,
      quantidade,
      preco: formPreco,
      nome,
    };
    cleanCamp();
    setProdutos((prev) => [dados, ...prev]);
  };

  const onSubmit = () => {
    if (produtos.length > 0) {
      const numeroPedido = getValues('numeroPedido');
      const idCompra = getValues('idCompra');
      const dados = {
        numeroPedido,
        idCompra,
        produtos,
      };
      dispatch(postEntradaNfProductThunk(dados));
    }
  };

  const handleProductFocus = () => {
    inputRefProduto.current?.focus();
  };

  const handleEnterPress = (event) => {
    // Adicionar produto quando clicado enter no ultimo campo do formulario
    if (event.key === 'Enter') {
      handleSubmit(addProduct)();
      handleProductFocus();
    }
  };

  return (
    <Main>
      <div className="w-[100%]">
        <Title>Entrada de produto ao estoque</Title>
      </div>
      <Form>
        <div className="flex gap-5 w-[90%] flex-wrap">
          <InputGlobal
            formCamp="numeroPedido"
            type="number"
            label="Pedido"
            placeholder="Digite o numerto do pedido"
            register={register}
            errors={errors?.numeroPedido ? errors : false}
            required={true}
            validations={{ required: true }}
          />
          <InputGlobal
            formCamp="idCompra"
            type="text"
            label="ID Requisicao"
            placeholder="Digite id e nome do pedido"
            register={register}
            errors={errors?.idCompra ? errors : false}
            required={true}
            validations={{ required: true }}
          />
        </div>
        <div className="flex justify-center gap-3 items-center w-[90%]">
          <div className="w-full sm:w-full sm:flex gap-3 sm:flex-wrap">
            <div className="w-full sm:flex-1">
              <Typography
                variant="h6"
                className="mb-1 text-left font-medium text-black dark:text-white capitalize"
              >
                Produto *
              </Typography>
              <ProdutoCod
                register={register}
                value={winthor}
                setValue={setWinthor}
                inputValue={inputValue}
                setInputValue={setInputValue}
                inputRef={inputRefProduto}
              />
              {formRequired && <MsgInputError text="Este campo é obrigatório" />}
            </div>
            <div className="flex gap-3 " onKeyDown={handleEnterPress}>
              <InputGlobal
                placeholder={'Digite quantidade utilizada'}
                formCamp="quantidade"
                type="number"
                label="Quantidade"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.quantidade ? errors : false}
              />
              <InputGlobal
                placeholder={'Digite preço'}
                formCamp="preco"
                type="number"
                label="Preço"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.preco ? errors : false}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-2 justify-between w-[80%]">
          <Adicionar
            text="Adicionar"
            click={handleSubmit(addProduct)}
            error={Object.keys(errors).length > 0 ? true : false}
          />
          <ButtonGlobal
            text="Salvar"
            click={onSubmit}
            loading={loading}
            disabled={produtos.length === 0}
          />
        </div>
        {success && <MsgSucess reset={resetInfo} outText="Produto adicionado ao estoque!!!" />}
      </Form>
      <div className=" w-[95%] h-[99%] overflow-auto mx-auto pb-2">
        <Paper
          sx={{
            width: '100%',
            height: '100%',
            overflow: 'auto',
            bgcolor: 'transparent',
          }}
        >
          <TableContainer sx={{ maxHeight: '100%' }}>
            <Table stickyHeader aria-label="sticky table" sx={{ textTransform: 'uppercase' }}>
              <TableHead>
                <TableRow>
                  <TableCell>Produto</TableCell>
                  <TableCell align="right">Quantide</TableCell>
                  <TableCell align="right">Preço</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="text-white">
                {produtos.map((produto, index) => (
                  <TableRow hover key={index}>
                    <TableCell>{produto.nome}</TableCell>
                    <TableCell align="right">{produto.quantidade}</TableCell>
                    <TableCell align="right">{produto.preco}</TableCell>
                    <TableCell align="right">
                      <Tooltip
                        content="Remover"
                        onClick={() => {
                          removeItemProduto(index);
                        }}
                      >
                        <Trash2
                          className="hover:text-red-500 cursor-pointer ml-auto"
                          onClick={() => {
                            removeItemProduto(index);
                          }}
                        />
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </Main>
  );
};

export default Entradas;
